import { FormikPanelProps } from 'panels'
import { useCallback, useState } from 'react'

export type FormikPanelState = Pick<
  FormikPanelProps,
  'initialValues' | 'onSubmit' | 'onDismiss' | 'isOpen'
>

export function useFormikPanelState<TValues>(
  options: Partial<FormikPanelState> = {}
) {
  const [panelState, setPanelState] = useState<{
    isOpen: boolean
    initialValues?: TValues
  }>({ isOpen: false, initialValues: options.initialValues })

  const hidePanel = useCallback(
    () => setPanelState({ isOpen: false }),
    [setPanelState]
  )
  const showPanel = useCallback(
    (values?: TValues) =>
      setPanelState({ isOpen: true, initialValues: values }),
    [setPanelState]
  )

  return [
    { ...panelState, onSubmit: options.onSubmit, onDismiss: hidePanel },
    showPanel,
    hidePanel,
  ] as [FormikPanelState, typeof showPanel, typeof hidePanel]
}
